import type { ResetPasswordSchema } from '@repo/schemas/auth/resetPassword';
import type { UseMutateAsyncFunction } from '@tanstack/react-query';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { ErrorMessageHandler } from '@repo/lib/errorMessageHandler';
import { resetPasswordErrorMessages } from '@repo/lib/messages/resetPasswordErrorMessages';
import { resetPassword } from '@repo/schemas/auth/resetPassword';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';

export const usePasswordResetForm = (mutateAsync: UseMutateAsyncFunction<string, Error, ResetPasswordSchema, unknown>) => {
  const [searchParams] = useSearchParams();
  const authToken = searchParams.get('t');

  const form = useForm<ResetPasswordSchema>({
    defaultValues: {
      email: '',
      authToken: authToken,
    },
    mode: 'onSubmit',
    resolver: standardSchemaResolver(resetPassword),
  });

  const onSubmit = async (data: ResetPasswordSchema) => {
    mutateAsync(data).catch((error) => {
      const errorHandler = new ErrorMessageHandler(resetPasswordErrorMessages);
      const { detail } = errorHandler.processError(error);
      form.setError('email', {
        type: 'manual',
        message: detail,
      });
    });
  };

  return { form: form, onSubmit: onSubmit };
};
